"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
function SvgVoice(props) {
    return ((0, jsx_runtime_1.jsxs)("svg", __assign({ viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M24.498 29.542l-2.391-2.388a1.676 1.676 0 00-2.39 0l-1.914 1.91c-2.773-1.337-5.546-4.107-6.79-6.877l1.817-1.91c.67-.668.67-1.719 0-2.292l-2.39-2.483a1.676 1.676 0 00-2.392 0l-2.39 2.483C1.545 22.092 17.899 38.52 22.107 34.318l2.39-2.388a1.67 1.67 0 000-2.388z", stroke: "currentColor", strokeWidth: 2 }, void 0), (0, jsx_runtime_1.jsx)("path", { clipRule: "evenodd", d: "M34.459 12.228c0 4.091-4.39 5.939-9.507 5.939L19.737 20.4v-4c-1-1-2.737-1.965-2.737-4.173C17 8.788 20.909 6 25.73 6c4.82 0 8.729 2.788 8.729 6.228z", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }, void 0)] }), void 0));
}
exports.default = SvgVoice;
//# sourceMappingURL=Voice.js.map